import { HttpClient, queryString } from '@opallabs/api'
import loadPresentationCounts from '../loadPresentationCounts'

const getPresentationCount = (params) => {
  const url = new URL('/api/v1/presentation_settings', window.location.origin)
  url.search = queryString(params)
  return HttpClient().get(url.toString())
}

const getPresentationCounts = (params) => (dispatch) => {
  const presentationSetting = {
    presentation_setting: params,
  }

  getPresentationCount(presentationSetting)
    .then((response) =>
      dispatch(loadPresentationCounts(response.data.data.attributes))
    )
    .catch((err) => {
      throw err
    })
}

export default getPresentationCounts
